export class ActionLockManager {
  static readonly ACTION_PENDING_ATTR = 'data-action-pending';
  static readonly ACTION_LOCKED_ATTR = 'data-action-locked';

  getActionElement(event: Event): HTMLElement | null {
    const path = event.composedPath();
    for (const node of path) {
      if (!(node instanceof HTMLElement)) continue;
      if (node.tagName.includes('-')) return node;
    }
    return null;
  }

  /** Returns true (and blocks) if this element already has a pending or locked interaction. */
  markPending(element: HTMLElement | null): boolean {
    if (!element) return false;
    if (element.hasAttribute(ActionLockManager.ACTION_PENDING_ATTR)) return true;
    if (element.hasAttribute(ActionLockManager.ACTION_LOCKED_ATTR)) return true;

    element.setAttribute(ActionLockManager.ACTION_PENDING_ATTR, 'true');
    return false;
  }

  clearPending(element: HTMLElement | null): void {
    if (!element) return;
    element.removeAttribute(ActionLockManager.ACTION_PENDING_ATTR);
  }

  isBlockedInteraction(event: Event): boolean {
    const path = event.composedPath();
    for (const node of path) {
      if (!(node instanceof HTMLElement)) continue;
      if (
        node.hasAttribute(ActionLockManager.ACTION_PENDING_ATTR) ||
        node.hasAttribute(ActionLockManager.ACTION_LOCKED_ATTR)
      ) {
        return true;
      }
    }
    return false;
  }
}